import React, { useEffect } from 'react';

const NewsTeasers = () => {
  useEffect(() => {
    if (!document.getElementById('bm-news-loader')) {
      const script = document.createElement('script');
      script.id = 'bm-news-loader';
      script.type = 'text/javascript';
      script.setAttribute('ignore-parser', 'true');
      script.setAttribute('data-brand', 'Ext');
      script.setAttribute('data-remote', 'https://s3-common-jscdn.berlingskemedia-testing.net/brands/testing/modules/dist');
      script.src = 'https://s3-common-jscdn.berlingskemedia-testing.net/brands/testing/modules/dist/loader.js';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className='mb-4' id="news-teasers">
      <news-teasers-list
        data-src="https://streams-eu2-cdn.k5a.io/streams/v1/617fdf37ed83c277493b2662/get/680a2cd0033c8327e831b38a"
        data-title="Euroinvestor aktienyt"
      />
      <news-teasers-list
        data-src="https://streams-eu2-cdn.k5a.io/streams/v1/617fdf37ed83c277493b2662/get/68218ba6fa901e123c3c4c5b"
        data-title=" "
        data-theme="dark"
      />
    </div>
  );
};

export default NewsTeasers;



// WEBPACK FOOTER //
// ./src/c/NewsTeasers.js